import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '@woolworthsnz/form';

@Component({
	selector: 'product-allow-subs',
	templateUrl: './allow-substitutes.component.html',
	styleUrls: ['./allow-substitutes.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, InputComponent],
})
export class AllowSubstitutesComponent implements OnInit {
	private _subsAllowed: boolean;

	allowSubstitutionForm: FormGroup;

	@Input() id: string;

	@Input()
	set subsAllowed(val: boolean) {
		this._subsAllowed = val;
		if (this.allowSubstitutionForm) {
			this.allowSubstitutionForm.patchValue({ [this.id]: val });
		}
	}

	@Output() changeEmitter: EventEmitter<any> = new EventEmitter();

	constructor(private fb: FormBuilder) {}

	ngOnInit(): void {
		this.allowSubstitutionForm = this.fb.group({ [this.id]: this._subsAllowed });
	}

	// eslint-disable-next-line @typescript-eslint/naming-convention
	handleAllowSubstitutionToggle($event: { target: { checked: boolean } }): void {
		this.changeEmitter.emit($event);
	}
}
